const DEVICE_INFO_CACHE_KEY = 'dokimo-deviceinfo-cache'

type CachedDeviceInfo = Record<string, unknown>

const isValidDeviceInfo = (deviceInfo?: CachedDeviceInfo | null) => {
  if (!deviceInfo || typeof deviceInfo !== 'object') {
    return false
  }

  return Boolean(deviceInfo.h_m || deviceInfo.token)
}

/** 将 deviceinfo 写入 sessionStorage，供三方支付回跳后恢复 */
export const persistDeviceInfoCache = (
  deviceInfo?: CachedDeviceInfo | null
) => {
  if (typeof window === 'undefined' || !isValidDeviceInfo(deviceInfo)) {
    return
  }

  try {
    window.sessionStorage.setItem(
      DEVICE_INFO_CACHE_KEY,
      JSON.stringify(deviceInfo)
    )
  } catch (_error) {
    // 隐私模式下 storage 不可用，忽略
  }
}

/** 从 sessionStorage 读取缓存的 deviceinfo */
export const restoreDeviceInfoCache = (): CachedDeviceInfo | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const raw = window.sessionStorage.getItem(DEVICE_INFO_CACHE_KEY)
    if (!raw) {
      return null
    }

    const deviceInfo = JSON.parse(raw) as CachedDeviceInfo
    return isValidDeviceInfo(deviceInfo) ? deviceInfo : null
  } catch (_error) {
    return null
  }
}

/** URL 上的 deviceinfo 字符串解析为对象 */
export const parseDeviceInfoQuery = (rawDeviceInfo?: string | null) => {
  if (!rawDeviceInfo) {
    return null
  }

  try {
    const deviceInfo = JSON.parse(rawDeviceInfo) as CachedDeviceInfo
    return isValidDeviceInfo(deviceInfo) ? deviceInfo : null
  } catch (_error) {
    try {
      const deviceInfo = JSON.parse(
        decodeURIComponent(rawDeviceInfo)
      ) as CachedDeviceInfo
      return isValidDeviceInfo(deviceInfo) ? deviceInfo : null
    } catch (_fallbackError) {
      return null
    }
  }
}
